import { VIDEO_PACKET_CONFIG, VIDEO_PACKET_FRAME } from "./video-protocol.js";

/** FastPubSub: только видео (live-edge, маленькая очередь). */
export class FastPubSubVideoTransport {
  constructor({ client, tenant, subjectPrefix, onVideoPacket, onWarning = console.warn }) {
    this.client = client;
    this.tenant = tenant;
    this.subjectPrefix = subjectPrefix;
    this.onVideoPacket = onVideoPacket;
    this.onWarning = onWarning;
    this.subscriptions = new Map();
  }

  videoChannel(subjectPrefix, quality) {
    return `${subjectPrefix}.media.video.${quality}`;
  }

  publishVideo(quality, payload) {
    return this.client.publish(this.tenant, this.videoChannel(this.subjectPrefix, quality), payload);
  }

  syncSubscriptions(channels) {
    this.sync(this.subscriptions, channels, channel => this.subscribeVideo(channel));
  }

  /** Синхронизирует карту подписок с нужным набором каналов. */
  sync(subscriptions, wanted, subscribe) {
    for (const [channel, subscription] of subscriptions) {
      if (wanted.has(channel)) continue;
      subscription.stopped = true;
      subscriptions.delete(channel);
      this.client.unsubscribe(this.tenant, `${channel}.#`).catch(this.onWarning);
    }
    for (const channel of wanted) {
      if (!subscriptions.has(channel)) subscribe(channel);
    }
  }

  async subscribeVideo(channel) {
    const subscription = { stopped: false };
    this.subscriptions.set(channel, subscription);
    try {
      const queue = await this.client.subscribe(this.tenant, `${channel}.#`, { queueCapacity: 8 });
      while (!subscription.stopped) {
        const message = await queue.recv();
        if (!message || subscription.stopped) break;
        if (message.payload[0] === VIDEO_PACKET_CONFIG) this.onVideoPacket(message.channel, message.payload);
        let newest = message.payload[0] === VIDEO_PACKET_FRAME ? message : undefined;
        let queued;
        while ((queued = queue.tryRecv())) {
          if (queued.payload[0] === VIDEO_PACKET_CONFIG) this.onVideoPacket(queued.channel, queued.payload);
          else if (queued.payload[0] === VIDEO_PACKET_FRAME) newest = queued;
        }
        if (newest) this.onVideoPacket(newest.channel, newest.payload);
      }
    } catch (error) {
      if (!subscription.stopped) this.onWarning(`video subscription ${channel}`, error);
    }
  }

  stop() {
    this.sync(this.subscriptions, new Set(), () => {});
  }
}
